import React from 'react'

const SberbankDevelopmentGrayLogo: React.FC<
  React.SVGProps<SVGSVGElement>
> = props => (
  <svg
    width="140"
    height="36"
    viewBox="0 0 140 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30488_10912)">
      <mask
        id="mask0_30488_10912"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="36"
      >
        <path d="M0 0H140V36H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_30488_10912)">
        <path
          d="M19.1977 30.721C22.7405 34.0971 27.536 35.9949 32.5368 36C37.5395 36.0012 42.3386 34.1055 45.8827 30.7282C49.4226 27.3528 51.4112 22.7736 51.4112 18C51.4106 15.6348 50.9219 13.293 49.9732 11.1088C49.0245 8.92465 47.6344 6.94108 45.8827 5.27184C42.3436 1.89648 37.5422 0 32.5368 0V5.13288C35.2044 5.13265 37.8125 5.88718 40.0328 7.30152C42.25 8.71362 43.9794 10.7232 45.0021 13.0759C46.0235 15.4274 46.2907 18.0144 45.7698 20.5106C45.2483 23.008 43.963 25.301 42.0771 27.0986C40.1883 28.8991 37.7846 30.1244 35.169 30.6202C32.5518 31.1166 29.8396 30.8619 27.3734 29.8879C24.9099 28.9153 22.803 27.2662 21.3188 25.1489C19.836 23.0328 19.0441 20.5452 19.0441 18H13.6624C13.6663 20.3642 14.1571 22.7046 15.1069 24.8873C16.0567 27.07 17.4467 29.0523 19.1977 30.721Z"
          fill="#8F98A1"
        />
        <path
          d="M83.669 30.7838H75.9637V30.7723C68.6499 30.7723 62.3167 27.0081 62.3167 18.78V17.1888C62.3167 8.88862 68.2457 5.20078 75.5543 5.20078H83.669V10.3301H75.5543C71.9873 10.3301 68.3744 11.7665 68.3744 17.201V18.7922C68.3744 24.0209 72.2334 25.6682 75.9637 25.6682H83.669V30.7838Z"
          fill="#8F98A1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.968 5.20078H126.352L126.34 5.2087C133.65 5.2087 139.983 8.97214 139.983 17.201V18.7922C139.983 27.096 134.058 30.7838 126.749 30.7838H115.968V5.20078ZM126.761 25.6675C130.329 25.6675 133.937 24.2311 133.937 18.7922V17.1931C133.937 11.9645 130.083 10.3171 126.352 10.3171H122.026V25.6675H126.761Z"
          fill="#8F98A1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.2074 15.4017H103.494C108.539 15.4017 112.255 16.9101 112.255 22.9178C112.255 29.0853 108.084 30.7241 103.494 30.7241H88.1452V5.14102H110.716V10.194H94.2074V15.4017ZM94.2074 25.6675H103.494L103.499 25.6668C105.005 25.6668 106.227 25.1887 106.227 23.0647C106.227 20.94 105.005 20.4626 103.499 20.4626H94.2074V25.6675Z"
          fill="#8F98A1"
        />
        <path
          d="M8.38362 32.9669C11.4895 34.9452 15.1378 36.0006 18.8693 36.0002L18.8701 30.8832C16.2031 30.8836 13.5956 30.1296 11.3756 28.716C9.15865 27.3045 7.42929 25.2957 6.40631 22.9437C5.38457 20.5941 5.11629 18.007 5.63556 15.5112C6.15584 13.0143 7.43947 10.7214 9.32373 8.92318C11.2108 7.12212 13.6129 5.89557 16.2274 5.39806C18.8432 4.89994 21.5545 5.15243 24.0207 6.12382C26.4848 7.09376 28.5933 8.74034 30.0799 10.8557C31.5637 12.9683 32.3578 15.455 32.3613 18.0002H37.743C37.7427 14.439 36.6358 10.9582 34.5629 8.00014C32.4863 5.03795 29.5386 2.7309 26.0921 1.37038C22.6423 0.00781256 18.8482 -0.348648 15.1872 0.345819C11.5281 1.03951 8.16553 2.75386 5.52341 5.27278C2.88519 7.7875 1.08727 10.9951 0.357707 14.4888C-0.370473 17.9805 0.00340422 21.6005 1.43179 24.8885C2.86233 28.18 5.28171 30.9914 8.38362 32.9669Z"
          fill="#8F98A1"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_30488_10912">
        <rect width="140" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SberbankDevelopmentGrayLogo
